import compact from "lodash/compact";
import get from "lodash/get";
import omit from "lodash/omit";
import React, { useMemo } from "react";
import { v4 as uuid } from "uuid";
import Popover from "./popover";
import { BASE_ELEMENT_IGNORED_FIELDS } from "./types/popoverProps";
const defaultProps = {
    popoverHeight: "auto",
    showEvent: "click",
    position: "bottom",
    hideOnOutsideClick: true
};
export default function withPopover(WrappedComponent) {
    function Hoc(props) {
        const { id: propsId, forwardedRef, ignoreHidingWhenChanged } = props;
        const id = useMemo(() => propsId || `popoverTarget_${uuid()}`, [propsId]);
        const canPopoverBeDisabled = get(props, "showEvent.name", props.showEvent) !== "dxhoverstart";
        return (React.createElement(React.Fragment, null,
            React.createElement(WrappedComponent, { ref: forwardedRef, ...omit(props, BASE_ELEMENT_IGNORED_FIELDS), id: id }),
            React.createElement(Popover, { ...omit(props, compact(["id", "forwardedRef", !canPopoverBeDisabled && "disabled"])), target: `#${id}`, ignoreHidingWhenChanged: ignoreHidingWhenChanged })));
    }
    Hoc.defaultProps = defaultProps;
    return Hoc;
}
